import axe from '../../services/axios-client/axiosClient';
import caller from './reportsSlice';

export const getReport = async (year) => {
  caller.reportPending();

  try {
    const response = await axe.get('/quotations/stats', {
      params: {
        year,
      },
    });
    caller.reportSuccess(response.data.data);
  } catch (error) {
    caller.reportRejected(error);
  }
};
